import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
var _excluded = ["href"];
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { jsx as _jsx } from "react/jsx-runtime";
export function searchParamsToObject(entries, exclude) {
  var result = {};
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      // each 'entry' is a [key, value] tupple
      if (!exclude.includes(key)) {
        result[key] = value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}

// Extracted from: https://reacthustle.com/blog/how-to-persist-nextjs-query-params-using-link-component
export var PersistQueryParamsLink = function PersistQueryParamsLink(_ref) {
  var href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  // 1. use useRouter hook to get access to the current query params
  var searchParams = useSearchParams();
  var searchParamsObject = searchParamsToObject(searchParams.entries(), props.exclude || []);

  // 2. get the pathname
  var pathname = typeof href === 'object' ? href.pathname : href;

  // 3. get the query from props
  var query = typeof href === 'object' && typeof href.query === 'object' ? href.query : {};
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    href: {
      pathname: pathname,
      // combine router.query and query props
      query: _objectSpread(_objectSpread({}, searchParamsObject), query)
    }
  }));
};
export default PersistQueryParamsLink;